import React, { Component } from 'react';
import { Visible } from './visible';

const shift = {
  minWidth: '100%',
  minHeight: '100%',
  top: '-1000%',
  left: '-1000%',
  bottom: '-1000%',
  right: '-1000%',
};

// based off http://stackoverflow.com/questions/18673900/how-to-center-and-crop-an-image-to-square-with-css
const styles = {
  wrapper: { whiteSpace: 'nowrap', overflow: 'hidden', position: 'relative' },
  img: { maxWidth: '100%', position: 'absolute', margin: 'auto', ...shift },
};

/**
 *    className prop can be used for setting media query sizes
 *    css 'maxHeight: ??vw' can be used to constrain the aspect ratio
 */
export class HeroImage extends Component {
  render() {
    const { breakpoint } = this.props;
    return (
      <div
        className={this.props.className}
        style={Object.assign({}, styles.wrapper, this.props.style)}
      >
        <Visible modes={(m) => m > 0}>
          <div className="banner">
            You are in preview mode. Once you register your website, you can
            customize this image.
          </div>
        </Visible>

        {this.maybeShowPrivateInstructionsBanner()}

        <picture>
          <source
            media={`(max-width: ${breakpoint - 1}px)`}
            srcSet={this.props.srcSetSmall}
          />
          <source
            media={`(min-width: ${breakpoint}px)`}
            srcSet={this.props.srcSetLarge}
          />
          <img
            style={styles.img}
            src={this.props.srcFallback || this.props.srcSetLarge.split(' ')[0]}
            alt="hero img"
          />
        </picture>
      </div>
    );
  }

  maybeShowPrivateInstructionsBanner = () => {
    if (this.props.isDirectlyFromPremiumFunnel) {
      return (
        <Visible modes={0}>
          <div className="perma-banner">
            {`You can make your website private by going to your Account Settings, at  `}
            <a href="/settings#academia-websites">academia.edu/settings</a>.
          </div>
        </Visible>
      );
    }
  };
}

HeroImage.defaultProps = {
  breakpoint: 901,
  style: {},
};

export default HeroImage;
